











import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class PreLoader extends Vue {}
